export const websocketTypes = {
  RESPUESTA_RESERVA: "reservaResponse",
  ACTUALIZACION_DE_CUPO: "cupoUpdate",
  ACTUALIZACION_OFERTA_KV: "generacionKvOferta",
  ACTUALIZACION_INSCRIPCION_KV: "generacionKvInscripcion",
  LOGOUT_GENERAL: "logoutGeneral",
  LOGOUT_ALUMNO: "logoutAlumno",
  WARNING_MENSAJE: "warningMensaje",
  CAMBIO_PRIORIDAD: "cambioPrioridad",
  CAMBIO_PRIORIDAD_ALUMNOS: "cambioPrioridadAlumnos",
  RESPUESTA_DESINSCRIPCION_ORACLE: "desinscripcionOracleResponse",
  RESPUESTA_INSCRIPCION_ORACLE: "inscripcionOracleResponse",
  CAMBIOS_EN_OFERTA: "cambiosEnOferta",
  CUPOS_RELOAD: "cuposReload",
  CARREAS_RELOAD: "carrerasReload",
  CUPOS_VALUE: `cupoValues`,
  CUPO_VALUES_COMPLETE: "cupoValuesComplete",
  CAMBIO_SECCION_OFERTA_VALUE: "cambioSeccionOfertaValue",
  CURSOS_BORRADOS: "cursosBorrados",
  LIMPIAR_CACHE_CATALOGO: "limpiarCacheCatalogo",
};
